import React from "react";
import { Grid } from "@mui/material";
import { StriimTypography } from "@striim/striim-ui";

import { styles } from "./validation-view.styles";

interface ValidationViewProps {
    title: string;
    description: string;
    validationComponent: JSX.Element;
}

const ValidationView: React.FC<ValidationViewProps> = ({ title, description, validationComponent }) => {
    return (
        <Grid container>
            <Grid container p={3} width={502}>
                <Grid item mb={1}>
                    <StriimTypography variant="h2">{title}</StriimTypography>
                </Grid>
                <Grid item>
                    <StriimTypography variant="body4" sx={styles.description}>
                        {description}
                    </StriimTypography>
                </Grid>
            </Grid>
            <Grid container p={3} sx={styles.border}>
                {validationComponent}
            </Grid>
        </Grid>
    );
};

export default ValidationView;
